// extracted by mini-css-extract-plugin
export default {"button":"dcc_cartboxE3DButton-button","icon":"dcc_cartboxE3DButton-icon","label":"dcc_cartboxE3DButton-label"};